import React from "react";
import { Presenter, prepareFormDef } from "../../data-entry/Presenter";
import { Page } from "../Page";
import { api } from "../../api/api";
import { form_def, ref } from "../../types";
import { Element } from "../../data-entry/types";
import { Inspector, InspectorContainer } from "../../data-entry/Inspector";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { useConditional } from "../../core/hooks/useConditional";
import { newID } from "../../core/utils/unique";
import { useApi } from "../../core/hooks/useApi";
import { CopyToClipboardCol, IDCol, LastUpdatedCol, SyncTableCol, TagsCol, TitleCol, VersionCol } from "../../layout/TableCells";
import { FormModal } from "../../data-entry/FormModal";
import { TagEditor } from "../../layout/TagEditor";
import { Checkbox } from "../../core/form/Checkbox";
import { useGlobalHandler } from "../../core/hooks/useGlobalHandler";
import { isObject, isString } from "../../core/utils/conversion";

export function Forms(props: {

}) {
	const [token, setToken] = React.useState("");

	const createModal = useConditional(() => {
		return (
			<FormModal
				form="form-create"
				onCancel={createModal.close}
				onSave={(value: form_def) => {

					const f = {
						...value,
						deleted: 0,
						data: {
							id: "@",
							type: "container",
							elements: [
								{
									type: "text",
									id: "0",
									title: "Field",
								}
							],
						},
					}

					api.form_def_post(f).then(() => {
						setToken(newID());
						createModal.close();
					}).catch(() => {
	
					});	
				}}
			/>
		)
	});

	return (
		<Page
			compact={true}
			title={{
				text: "Forms",
				icon: "form_color",
				buttons: [
					{ title: "Create" }
				]
			}}
			onButton={(btn) => {
				createModal.show({});
			}}
			
		>
			<FormList key={token} />

			{/* <EditForm def={def} /> */}

			{createModal.render()}
		</Page>
	);
}


export function FormList(props: {

}) {	
	
	const [token, setToken] = React.useState("");

	const state = useApi({
		request: () => api.form_def_get({}),

		prepareResult: (result) => {
			const state = {
				forms: result as form_def[],
				subForms: {} as any,
			};
			for(let f of state.forms) {
				state.subForms[f.id] = f;
			}
			
			state.forms.sort((a, b) => {
				return (a ? a.title : "").localeCompare(b ? b.title : "");
			});

			return state;
		}
	}, [token]);
	
	const edit = useConditional((def: form_def) => {
		return (
			<EditForm
				def={def}
				onSave={() => {
					edit.close();
					setToken(newID());
				}}
				onDelete={() => {
					api.form_def_delete({ id: def.id }).then(() => {
						setToken(newID());
						edit.close();

					}).catch(() => {

					})
				}}
			/>
		)
	})

	return (
		<>	
			<Table
				cols={[
					VersionCol(),
					IDCol(),
					TitleCol(),
					TagsCol(),
					LastUpdatedCol(),
					SyncTableCol({ container: "form_def", onSync: () => {
						setToken(newID());
					} }),
					CopyToClipboardCol(),
				]}
				items={state ? state.forms : []}
				interactive={true}
				onClick={(e, r) => {
					// first prepare the form (linking in subforms)
					prepareFormDef(r.data, state!.subForms)

					edit.show(r);
				}}
			/>
			{edit.render()}
		</>
	)
}

export function EditForm(props: {
	def: form_def,
	onSave: () => void,
	onDelete: () => void,
}) {
	const { def } = props;

	const formValues = {};

	// getting annoying issues in dev where bundle updates randomly causing page to reload, so prevent that
	useGlobalHandler("beforeunload", (e: any) => {
		e.preventDefault();
		e.returnValue = "";
	});

	function save() {
		// can't save the in-memory structure - it has things that shouldn't be persisted

		const obj = {
			id: def.id,
			title: def.title,
			deleted: def.deleted,
			data: JSON.parse(JSON.stringify(def.data)),
			meta: def.meta,
		};

		// also check through any subform references and remove the elements[] which were injected
		// and remove any unique ids
		function scan(e: any) {
			if (e.uniqueID) delete e.uniqueID;

			if (e.type === "sub-form") {
				delete e.elements;
			}

			function checkForEmptyDef(obj: any, arrProp: string) {
				const arr = obj[arrProp];

				if (!arr) return;

				function isThereAnyValue(obj: any) {
					for(let m in obj) {
						const p = obj[m];
						if (isObject(p)) {
							if (isThereAnyValue(p)) return true;
						} else {
							if (p !== null && p !== "" && p !== undefined) return true;
						}
					}
				}

				for(let i=arr.length-1;i>=0;i--) {
					const a = arr[i];
					if (!isThereAnyValue(a.options)) arr.splice(i, 1);
				}

			}

			function checkEmptyString(obj: any, prop: string) {
				const v = obj[prop];
				if (v === undefined) return;

				if (v === null || v === "" || (v.trim && v.trim() === "")) {
					delete obj[prop];
				}
			}

			const el = e as Element;

			const stringsToCheck = [
				"defaultValueScript",
				"filterScript",
				"title",
				"layout",
				
			];

			for(let s of stringsToCheck) {
				checkEmptyString(el, s)
			}



			if (el.events) {

				checkForEmptyDef(el.events, "change");
				checkForEmptyDef(el.events, "before-save");
				checkForEmptyDef(el.events, "default-value");
				checkForEmptyDef(el.events, "validate");

				if (el.events["before-save"] && el.events["before-save"].length === 0) delete el.events["before-save"];
				if (el.events.change && el.events.change.length === 0) delete el.events.change;
				if (el.events["default-value"] && el.events["default-value"].length === 0) delete el.events["default-value"];
				if (el.events.validate && el.events.validate.length === 0) delete el.events.validate;

				if (Object.keys(el.events).length === 0) delete el.events;

				if (el.validations && el.validations.length === 0) delete el.validations;
			}

			if (e.elements) {
				for(let child of e.elements) {
					scan(child);
				}
			}
		}
		scan(obj.data);

		api.form_def_post(obj).then(() => {
			props.onSave();

		}).catch(() => {

		});
	
	}

	if (!def) return null;


	return(
		<Modal
			editableTitle={{
				obj: def,
				prop: "title",
			}}
			editableSubtitle={{
				obj: def,
				prop: "id",
			}}
			titleCenter={
				<>
					<TagEditor dbObj={props.def} />
				</>
			}

			size="fullscreen"

			onSave={save}
			onCancel={props.onSave}
			cancelOnEscapeKey={false}
			saveOnEnterKey={false}

			showDelete={true}
			onDelete={props.onDelete}
		>
			<InspectorContainer>
				<Presenter
					designMode={true}

					def={def.data as Element}
					refs={def.refs}
					subForms={def.subForms}
					reports={def.reports!}

					formValues={formValues}
				>
					<Inspector />
				</Presenter>				
			</InspectorContainer>
		</Modal>
	);
}